module.exports = __webpack_public_path__ + "static/progress4-289b6d67d80f37091996d02e8d90ee37.png";